export default __webpack_public_path__ + "static/media/circle_1.21ed1af6.svg";